import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationHelperService {
  constructor(private translateService: TranslateService) { }

  setActiveLanguage(value: string, id: null | number): void {
    this.translateService.use(value);
    localStorage.setItem('language', value);
    let languageId: string = "";
    if (id != null) {
      languageId = id.toString()
    }
    localStorage.setItem('languageId', languageId);
  }

  initializeTranslate(): void {
    this.setActiveLanguage(this.languageFromLocalStorage, this.languageIdFromLocalStorage);
  }

  private get languageFromLocalStorage(): string {
    const langFromStorage = localStorage.getItem('language');

    if (langFromStorage) {
      return langFromStorage;
    } else {
      return 'en';
    }
  }

  private get languageIdFromLocalStorage(): number {
    const langIdFromStorage = localStorage.getItem('languageId');

    if (langIdFromStorage) {
      return parseInt(langIdFromStorage);
    } else {
      return 1;
    }
  }
}
